/**
 * Whether this refusal's message already accounts for a bare `null`: the class
 * has no such slot ({@link ParseError.keyVerdict}), or the setter refuses it
 * ({@link ParseError.nilVerdict}). Both ride on the error, since `findValidator`
 * returns a dispatcher and `withFiniteGuard` a wrapper, not the refusing leaf.
 */
export function ownsNilMessage(error) {
    return error.keyVerdict === true || error.nilVerdict === true;
}
//# sourceMappingURL=propertyValidator.js.map